var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"justify-center":"","align-center":"","wrap":"","mt-5":""}},[(_vm.data.length != 0)?_c('v-flex',{attrs:{"xs10":"","md6":"","mt-4":""}},[_c('carrusel-app',{attrs:{"data":_vm.data}})],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }